import { defineNuxtPlugin } from "#app";
import { useFetchMenuData } from "./composables/menu/useFetchMenuData.mjs";
export default defineNuxtPlugin(async (nuxtApp) => {
  const { fetchDataMenu, menuData } = await useFetchMenuData();
  nuxtApp.vueApp.provide("fetch_data_menu", fetchDataMenu);
  nuxtApp.vueApp.provide("global_menus", menuData);
});
